module.exports = __webpack_public_path__ + "media/images/workplace/job_type_bg/job_type_background_sentiment-916028aa22c0104633385cf6e0536cb0.svg";